import { render, staticRenderFns } from "./RemovePlan.vue?vue&type=template&id=1be36cc8&scoped=true"
import script from "./RemovePlan.vue?vue&type=script&lang=js"
export * from "./RemovePlan.vue?vue&type=script&lang=js"
import style0 from "./RemovePlan.vue?vue&type=style&index=0&id=1be36cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be36cc8",
  null
  
)

export default component.exports